<template>
  <v-container class="pa-0 settings_container">
      <sidebar />

      <div class="right_col_content">

        <!-- page content -->
        <router-view></router-view>
        <!-- /page content -->
      </div>


</v-container>
</template>

<script>
import moment from 'moment-timezone'
import Sidebar from '@/components/SettingsSidebar.vue'

export default {
  components: {
    Sidebar
  },
  data () {
    return {
      unit: '',
      timezone: '',
      localTimezone: ''
    }
  },
  methods: {
    init () {
      this.unit = this.$store.getters.settingParams.unit
      this.timezone = this.$store.getters.settingParams.timezone
      this.localTimezone = moment.tz.guess()
    }
  },
  mounted () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// Settings.vue?8c78f93c